import socket from './socket.js'
import account from './account.js'
import DataLoader from 'dataloader'
import { reactive } from 'vue'

const usersById = new Map(),
	usersByName = new Map(),
	usernames = [],
	userids = [],
	BROWSER = !process || ( process && process.browser ),
	ELECTRON_MAIN = process && process.type === 'browser',
	ELECTRON_RENDERER = !BROWSER && !process.type

let BrowserWindow,
	sendToAllWindows

if( ELECTRON_MAIN ){
	/*( async() => {
		const electron = await import( 'electron' )

		BrowserWindow = electron.BrowserWindow

		sendToAllWindows = ( eventName, ...rest ) => {
			BrowserWindow.getAllWindows().forEach( ( window ) => {
				window.webContents.send( eventName, ...rest )
			})
		}
	})()*/
}

export const newUser = ( data ) => {
	data = reactive( data )
	// this.lastUploadEpoch = 0

	usersById.set( data.id, data )
	usersByName.set( data.props.name.toLowerCase(), data.id )

	return data
}

if( ELECTRON_RENDERER ){

}
async function batchUserFetch( keys, task ){ //must return in order. null values or error for empty results
	const results = [],
		dontFetch = [],
		hash = task === 'id' ? usersById : usersByName
	keys.forEach( ( id, i ) => {
		if( task === 'name' ){
			id = id.toLowerCase()
		}
		if( hash[id] ){
			results[i] = hash[id]
			dontFetch.push( id )
		}
	})
	const toFetch = keys.filter( ( a ) => !dontFetch.includes( a ) )

	console.log( 'emit ack-users-by-' + task, toFetch )

	const finalizeResults = ( response ) => {
		console.log( 'got user data ack', response )
		response.forEach( ( userData, i ) => {
			if( !userData ){
				results[i] = null
			} else {
				userData = newUser( userData )
				results[i] = userData
			}
		})
	}

	if( ELECTRON_RENDERER ){
		return window.ipc.invoke( 'batchUserFetch', keys, task ).then( ( response ) => {
			finalizeResults( response )
			return results
		})
	} else {
		return new Promise( ( resolve ) => {
			socket.emit( 'ack-users-by-' + task || 'id', toFetch, ( response ) => {
				finalizeResults( response )
				resolve( results )
			})
		})
	}
}

class DualCache extends Map{
	async set( key, value ){
		const val = await value

		await super.set( val.props.name, val )
		return await super.set( val.props.id, val )
	}
}

const userCache = new DualCache(),
	userByIdLoader = new DataLoader( async( keys ) => {
		return await batchUserFetch( keys, 'id' )
	}, {
		cacheMap: userCache
	}),
	userByNameLoader = new DataLoader( async( keys ) => {
		return await batchUserFetch( keys, 'name' )
	}, {
		cacheMap: userCache
	})

export const getUserById = async( userid, callback ) => {
	const user = await userByIdLoader.load( userid )

	callback && callback( user )
	return user
}
export const getUserByName = async( username, callback ) => {
	const user = await userByNameLoader.load( username )

	callback && callback( user )
	return user
}

if( !ELECTRON_RENDERER ){
	socket.on( 'update-user', ( data ) => {
		const {id, ...props} = data
		getUserById( id ).then( ( user ) => {
			if( typeof props.animateIcon !== 'undefined' ){
				user.lastUploadEpoch = Date.now()
			}
			Object.entries( props ).forEach( ( [prop, value] ) => {
				user.props[prop] = value
			})
		})

		if( ELECTRON_MAIN ){
			sendToAllWindows( 'update-user', id, props )
		}
	})
	socket.on( 'update-user-priv', ( data ) => {
		for( const userid in data ){
			getUserById( userid, ( user ) => {
				user.priv.friends = value
				Object.entries( data[userid] ).forEach( ( [prop, value] ) => {
					user.priv[prop] = value
				})
			})

			if( ELECTRON_MAIN ){
				sendToAllWindows( 'update-user-priv', userid, data[userid] )
			}
		}
	})
}

export const oldImgUrl = ( user ) => {
	if( user && user.props.iconExt ){
		return '//img.rphaven.com/th_' + user.props.id + '.' + user.props.iconExt
	}
	return '//img.rphaven.com/noimage.webp'
}

export const imgUrl = ( user ) => {
	if( user && user.props.animateIcon !== null ){
		return `//img.rphaven.com/th${user.props.id}.webp`
	} else if( account.users.includes( user ) ){
		return '//img.rphaven.com/uploadhere.webp'
	}
	return '//img.rphaven.com/noimage.webp'
}

export const videoUrl = ( user ) => {
	if( user && user.props.animateIcon !== null && user.props.animateIcon === 1 ){
		return `//img.rphaven.com/${user.props.id}.webm`
	}
	return false
}

export const mapToStatusType = ( index ) => {
	const types = ['Basic', 'Busy']
	return types[index] || false
}

export const mapToAdType = ( index ) => {
	const types = ['Story Driven', 'Smut Driven']
	return types[index] || false
}

export default {
	oldImgUrl,
	imgUrl,
	mapToStatusType,
	videoUrl,
	getById: getUserById,
	getByName: getUserByName,
	new: newUser
}
